import { EDITOR, FIELDSET, GENERAL, NS_CONFIGURATION, PROJECT } from 'redux/constants';
import { action, ASYNC, SYNC, createType } from 'redux-create-type';
import { createSetCostOfEstimationActions } from '../../../../../../helpers';

export const {
  INIT,
  RESET_CHANGES,
  SET_COST_OF_ESTIMATION,
  SET_ESTIMATION_UNIT,
  SAVE,
  SET_NAME,
  CHANGE_ACTIVITY  
} = createType(NS_CONFIGURATION, PROJECT, EDITOR, GENERAL, FIELDSET)({
  INIT: ASYNC,
  RESET_CHANGES: ASYNC,
  SET_COST_OF_ESTIMATION: ASYNC,
  SET_ESTIMATION_UNIT: ASYNC,
  SAVE: SYNC,
  SET_NAME: ASYNC,
  CHANGE_ACTIVITY: ASYNC
});

export const init = {
  begin: ({ project, companyId }) => action(INIT.BEGIN, { project, companyId }),
  end: ({ origProject, project }) => action(INIT.END, { origProject, project }),
};

export const resetChanges = {
  begin: () => action(RESET_CHANGES.BEGIN),
  end: ({ origProject }) => action(RESET_CHANGES.END, { origProject }),
};

export const save = ({ project }) => action(SAVE, { project });

export const setCostOfEstimation = createSetCostOfEstimationActions(SET_COST_OF_ESTIMATION);

export const changeActiveFlag = {
  begin: ({ name }) => action(CHANGE_ACTIVITY.BEGIN, { name }),
  end: ({ isNameUnique }) => action(CHANGE_ACTIVITY.END, { isNameUnique})
};

export const setName = {
  begin: ({ name }) => action(SET_NAME.BEGIN, { name }),
  end: ({ isNameUnique }) => action(SET_NAME.END, { isNameUnique})
};

export const setEstimationUnit = {
  begin: ({ estimationUnit }) => action(SET_ESTIMATION_UNIT.BEGIN, { estimationUnit }),
  end: ({ isCostOfEstUnitVisible }) => action(SET_ESTIMATION_UNIT.END, { isCostOfEstUnitVisible})
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/general/fieldset/actions.js